module.exports = __webpack_public_path__ + "media/application/images/iod-b11d4a0d261ac469636550971576154a.png";